module.exports = __webpack_public_path__ + "static/la-ventures--brennan-ong-460120d173eaded35207a388f5f35134.mp4";